/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var FormUtils = require('../../../../../utils/FormUtils');
var HorizontalFields = require('ES/widgets/HorizontalFields');
let AccountingLockedWarning = require("../../AccountingLockedWarning");
var EventFormUnsavedChangeMixin = require('../../EventFormUnsavedChangeMixin');

module.exports = dd.createClass({
	__onSubmit: function(data){
		var event = _.cloneDeep(this.props.event);
		var service = this.props.service;

		if(!_.isArray(event.Service)){
			event.Service = [];
		}
		if(!service || service.id < 0){
			service = {id: 0, eid: event.eid};
			event.Service.push(service);
		}
		_.each(event.Service, function(item){
			if(item.id == service.id){

				item.groupcode = _.get(data, "groupcode", "").trim().toUpperCase();
				item.description = (data.description || "").trim();
				item.due = _.isDate(data.due) ? data.due : 0;

				if(/actual/i.test(data.amount)){
					item.fee = 0;
					_.set(item, ["flags_as_map", "bill_later", "is_set"], true);
				}else if(/free/i.test(data.amount)){
					item.fee = 0;
					_.set(item, ["flags_as_map", "free", "is_set"], true);
				}else{
					item.fee = parseFloat(data.amount.replace(/(\$| )/g, ''));
				}
			}
		});
		radio('save_Event').broadcast(event);
		this.__close();
	},
	__deleteIt: esUtils.wrapPreventDefault(function(){
		var event = _.cloneDeep(this.props.event);
		var service = this.props.service;
		event.Service = _.reject(event.Service, function(item){
			return item.id == service.id;
		});
		radio("save_Event").broadcast(event);
		this.__close();
	}),
	__close: function(){
		if(_.isFunction(this.props.onCancel)){
			this.props.onCancel();
		}
	},
	render: function(){
		var event = this.props.event;
		var Displaylists = this.props.Displaylists;
		var service = this.props.service;
		var onCancel = this.props.onCancel;

		return dd.div({className: 'ServiceForm'},
			DaForm({
				event: event,
				Displaylists: Displaylists,
				service: service,
				onSubmit: this.__onSubmit,
				deleteIt: this.__deleteIt,
				onCancel: onCancel
			})
		);
	}
});

var DaForm = dd.createClass({
	mixins: [FormMixin, _.omit(EventFormUnsavedChangeMixin, 'onFormChanged')],
	getInitialValuesSourceVersion: function(props){
		var service = this.props.service;
		return service && service.id > 0 ? service.id : 0;
	},
	getInitialValues: function(props){
		var service = props.service;
		if(!service){
			return null;
		}
		var isFlag = function(f){
			return _.get(service, ["flags_as_map", f, "is_set"], false);
		};
		var amount = service.fee;
		if(isFlag('free')){
			amount = 'Free';
		}else if(isFlag('bill_later')){
			amount = 'Actual';
		}
		return {
			groupcode: service.groupcode,
			due: service.due,
			description: service.description,
			amount: amount + ""//must be string
		};
	},
	onFormChanged: function(field_path, new_value){
		if(field_path === 'groupcode'){
			var data = this.state.data || {};
			var service_codes = this.__getServiceCodes();
			var code = service_codes[new_value];
			if(code){
				data.description = code.description;
				data.amount = code.fee + "";//must be string
				data.groupcode = code.groupcode;
				this.setState({data: data});
			}
		}
		//from EventFormUnsavedChangeMixin
		this.__checkForChangesMade();
	},
	__getServiceCodes: function(){
		var event = this.props.event;
		var Displaylists = this.props.Displaylists;

		var service_codes = [];
		if(Displaylists && event){
			service_codes = _.reduce(_.filter(Displaylists.perspeaker, function(speaker){
				return _.includes(event.sids, speaker.sid);
			}), function(list, speaker){
				return list.concat(speaker.servicecodes);
			}, []);
		}
		return service_codes;
	},
	buildFields: function(){
		var schema = {
			groupcode: {
				label: 'Code',
				type: 'combo',
				options: _.object(_.map(this.__getServiceCodes(), function(code, i){
					return [i, code.groupcode];
				})),
				placeholder: 'Code',
				tooltip: 'A 4-character code you make up to categorize your income in eSpeakers reports. Not seen by customers - use whatever makes sense in your office. Examples: KEYN for "keynote fee", TRAV for "travel expenses", etc...'
			},
			due: {
				label: 'Due Date',
				type: 'date',
				tooltip: 'The date this item should be paid by the client.',
				validate: FormUtils.v.optional
			},
			description: {
				label: 'Description',
				type: 'text',
				placeholder: 'Description',
				tooltip: 'Describe the purpose of this item. Examples: "standard keynote fee", "flat travel fee".',
				validate: FormUtils.v.optional
			},
			amount: {
				label: 'Amount',
				type: 'combo',
				options: {
					Free: 'Free',
					Actual: 'Actual Cost'
				},
				validate: function(value){
					var validAmount = /^ *(\-? *[$]? *\-? *[0-9,]*[.]?[0-9]?[0-9]?|Actual|Free) *$/i;
					return (validAmount.test(value) && value.trim().length > 0) || 'Enter an amount or FREE or ACTUAL';
				},
				placeholder: 'Amount',
				tooltip: 'The amount, in USD, you are charging the customer. Most often you will enter dollars and cents here, but you can choose ACTUAL COST to indicate you will provide the amount later, or FREE to indicate there is no charge for this item. You can use a negative number to indicate a commission or other expense.'
			}
		};
		return schema;
	},
	__onCancel: esUtils.wrapPreventDefault(function(){
		this.updateUnsavedState(false);
		this.props.onCancel();
	}),
	render: function(){
		var fields = this.buildFields();
		var errors = this.state.errors || {};
		var {event, service, deleteIt} = this.props;

		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}),
			HorizontalFields.FormButtons({
				right_align_buttons: true,
				submit_btn_text: service && service.id > 0 ? 'Save' : 'Add',
				onDelete: service && service.id > 0 ? deleteIt : null,
				onCancel: this.__onCancel
			}),
			AccountingLockedWarning({event})
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/services/ServiceForm.js